// eslint-disable-next-line import/no-extraneous-dependencies
import Rules from '@mcfe/tools-rules';

export const priceTableRules = {
    bidPrice: [Rules.typeValid({ type: 'number' }, '请输入数字'), Rules.range({ min: 0, le: false }, '请填写正数'), Rules.decimalLen({ len: 2 }, '最多两位小数')],
};

export const extractFieldFromSkuList = (detailSkuList, field) => {
    if (!Array.isArray(detailSkuList)) {
        return '';
    }
    const extractSkuNames = (list = []) => list.flatMap((item) => {
        const skuGroup = item.skuGroup || [];
        return skuGroup.flatMap((group) => {
            const skuList = group.skuList || [];
            return skuList.map((sku) => sku[field]).filter((value) => value !== -1 && value !== ''); // 过滤掉-1和空值;
        });
    });

    const namesArray = extractSkuNames(detailSkuList);
    return namesArray.join(', ');
};

export const defaultTaskForm = () => ({
    title: '',
    secCategoryId: '',
    tenderBeginTime: null,
    tenderEndTime: null,
    instruction: '',
    documentationRequirement: '',
    cityList: [],
    amount: '',
    qualityRequirement: '',
    fulfillmentRequirement: '',
    accessoryFiles: [],
    allowedBidderType: null, // 可投标商类型
});
export const BIDDING_TYPE = {
    ALL: 1,
    DIRECT: 2,
    NON_DIRECT: 3,
};
// 可投标商类型
export const canBiddingList = [
    {
        tips: '',
        label: '直供商/非直供商均可',
        value: BIDDING_TYPE.ALL,
    },
    {
        tips: '当前标书仅允许直供商投标，非直供商请勿投标（直供商指供应商直接向小象超市供货，小象超市作为购销方进行直接采购，非直供商指供应商在合作过程中作为经销商为上游提供托盘服务，并承担上游责任）',
        label: '直供商',
        value: BIDDING_TYPE.DIRECT,
    },
    {
        tips: '当前标书仅允许非直供商投标，直供商请勿投标（直供商指供应商直接向小象超市供货，小象超市作为购销方进行直接采购，非直供商指供应商在合作过程中作为经销商为上游提供托盘服务，并承担上游责任）',
        label: '非直供商',
        value: BIDDING_TYPE.NON_DIRECT,
    },
];

export const SelectionMode = {
    // 多选模式
    MULTIPLE: 1,
    // 单选模式
    SINGLE: 2,
};

export const inputType = {
    // 仅输入-数字
    NUMBER: 1,
    // 不限制输入
    NORMAL: 2,
};
